import React from 'react';
import { AiFillStar } from "react-icons/ai";
function StarIcon(props) {
    return (
        <div className="font_color star_icon">
           < AiFillStar/>
        </div>
    );
}

export default StarIcon;